import React from 'react';
import './Home.css';
import HeroSection from '../unAuth/Components/hero section';
import Assets from '../unAuth/Components/assets';
import TeamSection from '../unAuth/Components/team section';
import ValueBenefits from '../unAuth/Components/ValueBenefits';
import TokenizationSteps from '../unAuth/Components/TokenizationSteps';
import Footer from '../unAuth/Components/footer';


const Home = ({ onLearnMore }) => {

  return (
    <div className="home-page">
      <div id="home">
        <HeroSection onLearnMore={onLearnMore} />
      </div>
      <div id="team">
        <TeamSection onLearnMore={onLearnMore} />
      </div>
      <div id="value-benefits">
        <ValueBenefits />
      </div>
      <div id="assets">
        <Assets onLearnMore={onLearnMore} />
      </div>
      <div id="tokenization-steps">
        <TokenizationSteps onLearnMore={onLearnMore} />
      </div>
      <Footer />
    </div>
  );
};

export default Home;
